var _circle, _circle2, _path, _circle3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 100,
    viewBox: "0 0 108 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#898989",
    fillOpacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    stroke: "#898989",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.479 51.5176H45.6445V49.9136H48.479V47.0571H50.083V49.9136H52.9175V51.5176H50.083V54.3374H48.479V51.5176Z",
    fill: "#898989",
    fillOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 79.5,
    r: 17.5,
    fill: "#227F99"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_4022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.371 73.75L86.871 75.25H84V84.25H96V75.25H93.129L91.629 73.75H88.371ZM87.75 72.25H92.25L93.75 73.75H96.75C96.9489 73.75 97.1397 73.829 97.2803 73.9697C97.421 74.1103 97.5 74.3011 97.5 74.5V85C97.5 85.1989 97.421 85.3897 97.2803 85.5303C97.1397 85.671 96.9489 85.75 96.75 85.75H83.25C83.0511 85.75 82.8603 85.671 82.7197 85.5303C82.579 85.3897 82.5 85.1989 82.5 85V74.5C82.5 74.3011 82.579 74.1103 82.7197 73.9697C82.8603 73.829 83.0511 73.75 83.25 73.75H86.25L87.75 72.25ZM90 83.5C88.906 83.5 87.8568 83.0654 87.0832 82.2918C86.3096 81.5182 85.875 80.469 85.875 79.375C85.875 78.281 86.3096 77.2318 87.0832 76.4582C87.8568 75.6846 88.906 75.25 90 75.25C91.094 75.25 92.1432 75.6846 92.9168 76.4582C93.6904 77.2318 94.125 78.281 94.125 79.375C94.125 80.469 93.6904 81.5182 92.9168 82.2918C92.1432 83.0654 91.094 83.5 90 83.5ZM90 82C90.6962 82 91.3639 81.7234 91.8562 81.2312C92.3484 80.7389 92.625 80.0712 92.625 79.375C92.625 78.6788 92.3484 78.0111 91.8562 77.5188C91.3639 77.0266 90.6962 76.75 90 76.75C89.3038 76.75 88.6361 77.0266 88.1438 77.5188C87.6516 78.0111 87.375 78.6788 87.375 79.375C87.375 80.0712 87.6516 80.7389 88.1438 81.2312C88.6361 81.7234 89.3038 82 90 82Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_4022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(81 70)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/uploadImage.214b09702dbbb8dac581c133d0eb4dd6.svg";
export { ForwardRef as ReactComponent };